<template>
  <div class="deleteLicense">
    <el-card class="box-card">
      <h2>Delete License</h2>
      <el-form ref="LicenseForm" label-position="left" :model="LicenseForm" label-width="150px">
        <el-form-item label="Project Name">
          <el-input disabled v-model="LicenseForm.project"></el-input>
        </el-form-item>
        <el-form-item label="Direct Customer">
          <el-input disabled v-model="LicenseForm.direct_cus"></el-input>
        </el-form-item>
        <el-form-item label="Expiry Date" style="text-align:left;">
          <el-col :span="11">
            <el-date-picker v-show="!checked" disabled type="date" placeholder="Select Date" v-model="LicenseForm.exp_date" value-format="timestamp"
                            style="width: 100%;"></el-date-picker>
          </el-col>
          <el-checkbox v-show="checked" v-model="checked" disabled>No Limit</el-checkbox>
        </el-form-item>
        <el-form-item label="Customer Email">
          <el-input disabled type="email" placeholder="Email Address" v-model="LicenseForm.user_email" clearable></el-input>
        </el-form-item>
        <el-form-item label="ER Number">
          <el-input disabled placeholder="ER Number" v-model="LicenseForm.er_num" clearable></el-input>
        </el-form-item>
        <el-form-item label="NE Point">
          <el-input disabled placeholder="NE Point" type="textarea" v-model="LicenseForm.ne_point" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <router-link to='search'><el-button type="danger" plain>Cancel</el-button></router-link>
          <el-button type="success" plain @click="onClick()" :loading="deleting">Confirm to Delete</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import {deleteLicense} from '../api'
import moment from 'moment'
export default {
  name: 'DeleteLicense',
  data () {
    return {
      deleting: false,
      checked: false,
      outerlicense: this.$route.params.data.outerlicense,
      interlicense: this.$route.params.data.interlicense,
      LicenseInfo: this.$route.params.data,
      LicenseForm: {
        project: this.$route.params.data.project,
        direct_cus: this.$route.params.data.direct_cus,
        exp_date: this.$route.params.data.exp_date,
        user_email: this.$route.params.data.user_email,
        er_num: this.$route.params.data.er_num,
        ne_point: this.$route.params.data.license_content.all_feature
      }
    }
  },
  created: function () {
    this.checked = this.LicenseForm.exp_date === -1
  },
  methods: {
    onClick () {
      console.log('onClick Delete')
      console.log('outerlicense')
      console.log(this.outerlicense)
      console.log('interlicense')
      console.log(this.interlicense)

      this.deleting = true
      deleteLicense(this.outerlicense, this.interlicense).then(data => {
        this.deleting = false
        this.$notify({
          title: 'Success',
          message: 'Delete License Successfully',
          type: 'success'
        })
        /* this.$message({
          showClose: true,
          message: 'Delete License Successfully',
          type: 'success'
        }) */

        /* this.$alert('License is deleted', 'Delete License', {
          confirmButtonText: 'OK',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${action}`
            })
          }
        }) */
        this.$router.push({name: 'Search'})
      })
    },
    // Format Timestamps
    dateFormat: function (row, column) {
      var date = row[column.property]
      if (date === -1) {
        return 'No Limit'
      }
      if (date === undefined) {
        return ''
      }
      return moment.utc(date).format('YYYY-MMM-DD HH:mm:ss', true)
    },
    arrayFormat: function (row, column) {
      var arrayInput = row[column.property]
      if (arrayInput === undefined) {
        return ''
      }
      if (Array.isArray(arrayInput)) {
        return arrayInput.join()
      } else {
        return arrayInput
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.welcome{
  margin: 0px auto;
  max-width: 350px;
  position: relative;
  margin-top: 50px;
}
</style>

<style>
.el-table .cell {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// DeleteLicense.vue?2c042712